import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { IClassificacaoMercadologica, StringUtilsService } from '@vip/core';

@Component({
  selector: 'vip-dropdown-secoes',
  templateUrl: './dropdown-secoes.component.html',
  styleUrls: ['./dropdown-secoes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class DropdownSecoesComponent implements AfterViewChecked {
  @Input() items!: IClassificacaoMercadologica[];
  @Input() hasCategories = false;
  @Output() itemClick = new EventEmitter<IClassificacaoMercadologica>();

  @ViewChild('sectionsContainer') sectionsContainerRef!: ElementRef<HTMLDivElement>;
  @ViewChildren('itemsDropdown') itemsDropdown!: QueryList<ElementRef>;

  itemsQuantity = 0;
  showQtd = 20;

  constructor(
    private cdr: ChangeDetectorRef,
    public stringUtilsService: StringUtilsService,
  ) {}

  get hasShowMoreButton(): boolean {
    return this.items && this.items.length > this.showQtd;
  }

  buildUrl(node: IClassificacaoMercadologica): string {
    const part = node.link?.startsWith('/') ? node.link : '/' + node.link;
    return '/departamentos' + part;
  }

  ngAfterViewChecked(): void {
    this.itemsQuantity = this.itemsDropdown.length;
    this.cdr.detectChanges();
  }

  emitClick(node: IClassificacaoMercadologica): void {
    this.itemClick.emit(node);
  }

  handleShowMore(): void {
    this.showQtd = this.items.length;
  }

  showMoreAndRefocus(): void {
    const willRemoveButton = this.hasShowMoreButton;
    this.handleShowMore();
    if (willRemoveButton) {
      const focusFn = () => this.sectionsContainerRef?.nativeElement?.focus();
      if (typeof queueMicrotask === 'function') {
        queueMicrotask(focusFn);
        return;
      }

      setTimeout(focusFn, 0);
    }
  }

  trackByFn(_: number, item: IClassificacaoMercadologica): number {
    return item.classificacao_mercadologica_id;
  }
}
